import { apiGetUserInfo, apiGet_cp_url } from '@/resource'
import store from '@/store'
import router from '@/router'
import { getRegulator } from '@/util/regulator'
import { getCookies, setCookies } from '@/util/cookies'
import config from '@/config'
import { getAuditStatusByString } from '@/constants/auditStatus'
import { getAppUserInfoStorage, setCreateTime } from '@/util/appUserInfoStorage'
import { handleError } from './handleError'
import { sensorsBindLogin, sensorsLogout, sensorsRegister } from './sensorsdata'
import { redirect } from '@/util/webview'

function setUserInfo(userInfo, type) {
  const poiAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.poiAuditStatus)
  const poaAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.poaAuditStatus)
  const ibtPoiAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.ibtPoiAuditStatus)
  const ibtPoaAuditStatus = getAuditStatusByString(userInfo.identityProofStatus.ibtPoaAuditStatus)

  store.dispatch('regulator/actionGetInformation')
  store.commit('common/setAccessToken', userInfo.accessToken)
  setCookies('xtoken', userInfo.accessToken)
  store.commit('common/setIsSubUser', userInfo.isSubUser)
  store.commit('common/setSubUserSwitch', userInfo.subUserSwitch)
  store.commit('common/setPermissionIds', userInfo.permissionIds)
  store.commit('common/setSubEmail', userInfo.subEmail)
  store.commit('common/setLoginStatus', true)
  store.commit('common/setUserName', userInfo.userName)
  store.commit('common/setEmail', userInfo.email)
  store.commit('common/setEmailMasked', userInfo.emailMasked)
  store.commit('common/setPhone', userInfo.phone)
  store.commit('common/setCreateTime', userInfo.date)
  store.commit('common/setAddress', userInfo.address)
  store.commit('common/setLang', userInfo.language)
  store.commit('common/setCountryCode', userInfo.countryCode)
  store.commit('common/setSalesCompany', userInfo.salesCompany)
  store.commit('common/setPoiAuditStatus', poiAuditStatus)
  store.commit('common/setPoaAuditStatus', poaAuditStatus)
  store.commit('common/setIbtPoiAuditStatus', ibtPoiAuditStatus)
  store.commit('common/setIbtPoaAuditStatus', ibtPoaAuditStatus)
  store.commit('common/setId3Pass', userInfo.id3Pass ?? false)
  store.commit('common/setRegulator', getRegulator(userInfo.regulator))
  store.commit('common/setUserId', userInfo.userId)
  store.commit('common/setEventEmailId', userInfo.eventEmailId)
  store.commit('common/setEventMobileId', userInfo.eventMobileId)
  store.commit('common/setRegulator', getRegulator(userInfo.regulator))
  store.commit('telegram/setUserProfile', userInfo)

  sensorsRegister({
    is_login: true,
  })
  sensorsBindLogin(userInfo.userId, userInfo.eventEmailId, userInfo.eventMobileId)

  setCookies('cpUrl', userInfo.url, 60 * 24 * 30)
}

export default {
  signOut(method = 'backToClientPortal', path = '') {
    const accessToken = store.state.common.accessToken
    const racc = getCookies('racc')
    const atid = getCookies('atid')

    store.commit('common/reset')
    store.commit('behavior/reset')
    store.commit('regulator/reset')
    store.commit('common/setSessionId', { sessionId: null, sessionInternalId: null })
    setCookies('xtoken', '')
    if (racc) setCookies('racc', '')
    if (atid) setCookies('atid', '')
    sensorsRegister({
      is_login: false,
    })
    sensorsLogout()
    this.getCpUrl(method, accessToken, path)
  },
  async loginByToken(accessToken, pk) {
    try {
      setCookies('xtoken', accessToken)
      const res = await apiGetUserInfo()
      const { code, data } = res.data

      if (code === 200) {
        const userInfo = data
        setUserInfo({ ...userInfo, accessToken }, 'web')
      }

      if ([200, 1500].includes(code)) {
        router.push('/home')
      }
    } catch (error) {
      console.log(error, 'error')
      router.go(-1)
      handleError(error) // 如果需要调用处理错误的函数
    }
  },
  async apiLoginByApp(isToHome) {
    try {
      const res = await apiGetUserInfo()
      const { code, data } = res.data
      if (code !== 200) return
      // 通过app的token获取用户信息
      const userInfo = data
      const appUserInfo = getAppUserInfoStorage()
      const { lang, xtoken } = appUserInfo
      // 缓存用户信息创建时间
      setCreateTime()
      userInfo.language = lang
      setUserInfo({ ...userInfo, accessToken: xtoken }, 'app')
      store.commit('common/setIsFromApp', true)
      isToHome && router.push('/home')
      setTimeout(() => {
        this.apiLoginByApp(true)
      }, 30 * 60 * 1000)
    } catch (err) {
      // app端需要推出
      const { isFromApp } = store.state.common
      setCookies('xtoken', '')
      isFromApp && redirect(501)
    }
  },
  async loginByApp() {
    try {
      this.apiLoginByApp(true)
    } catch (e) {
      setCookies('xtoken', '')
      redirect(501)
    }
  },
  getCpUrl(method, accessToken, path = '') {
    const cpUrl = getCookies('cpUrl')
    if (method === 'logout') store.commit('common/setAutoNotifyStatus')
    if (cpUrl) this.goToCp(method, cpUrl, accessToken, path)
    else
      apiGet_cp_url().then(resp => {
        const userInfo = resp.data.data
        setCookies('cpUrl', userInfo, 60 * 24 * 30)
        this.goToCp(method, userInfo, accessToken, path)
      }, handleError)
  },
  async goToCp(method = 'backToClientPortal', cpUrl = config.cpUrl, accessToken = '', path) {
    const baseUrl = process.env.NODE_ENV == 'development' ? 'http://localhost:8084/' : cpUrl
    let cpPath = ''
    if (path != null) cpPath = `&path=${path}`

    if (method == 'logout') {
      window.location = baseUrl + `logout?lang=${store.state.common.lang}`
    } else {
      try {
        window.location = `${baseUrl}?accessToken=${accessToken}${cpPath}`
      } catch (err) {
        console.log(err)
      }
    }
  },
}
